import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import scss from './SendRequestModal.module.scss';
// import { useTranslation } from 'react-i18next';
// import { useParams } from 'react-router-dom';
import { houseCards } from 'components/UserCards/HouseCards';
import GalleryComponent from 'pages/HousePage/HouseComponents/GalleryComponent';
import closeSvg from 'assets/icons/userCabinetSendReq/close.svg';
import { ObjectDescr } from './ObjectDescr';
import { RathingBlock } from './RathingBlock';
import { PaymentBlock } from './PaymentBlock';
import { DescriptionBlock } from './DescriptionBlock';
import { Feedback } from './Feedback';
import Amenities from './Amenities';
import RoomDetails from './RoomDetails';
export const SendRequestModal = ({ onClose, id }) => {
    // const { id } = useParams(); // получаем id из Link
    let place = {
        rating: '',
        id: 0,
        album: [],
        minArea: 0,
        minPrice: 0,
        feedbackAmount: 0,
        url: '',
        title: '',
        address: '',
        type: '',
        checkIn: '',
        checkOut: '',
        options: '',
    };
    houseCards.some(card => {
        if (card.id === +id) {
            place = card;
            return true;
        }
        return false;
    });
    // const { t } = useTranslation();
    // export const upperCaseLangCodes = {
    // 	ua: 'UA' as const,
    // 	en: 'EN' as const,
    // 	ru: 'RU' as const,
    // 	pl: 'PL' as const,
    // };
    return (_jsx("div", Object.assign({ className: scss.SendRequest__backdrop }, { children: _jsxs("article", Object.assign({ className: scss.SendRequest__thumb }, { children: [_jsx("button", Object.assign({ className: scss.SendRequest__closeButton, onClick: onClose }, { children: _jsx("img", { src: closeSvg, alt: "Close", onClick: onClose }) })), _jsx("div", Object.assign({ className: scss.SendRequest__Btn }, { children: _jsxs("div", Object.assign({ className: scss.SendRequest__reserveBlock }, { children: [_jsx("div", { className: scss.SendRequest__buttonThumb }), _jsx("button", Object.assign({ className: scss.SendRequest__reserveButton, onClick: () => console.log('Заброніровав, красава!') }, { children: "\u0417\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C" }))] })) })), _jsxs("section", Object.assign({ className: scss.SendRequest__modalBlock }, { children: [_jsx("div", Object.assign({ className: scss.Video__thumb }, { children: _jsxs("video", Object.assign({ className: scss.SendRequest__modalCompomnent, controls: true }, { children: [_jsx("source", { src: "your_video_path_here.mp4", type: "video/mp4" }), "Your browser does not support the video tag."] })) })), _jsx("div", Object.assign({ className: scss.Gallery__thumb }, { children: _jsx(GalleryComponent, { album: place.album, collums: "3", children: undefined, childrenPosition: undefined }) }))] })), _jsx("section", Object.assign({ className: scss.DescReserveBlock }, { children: _jsx("aside", { children: _jsx(ObjectDescr, { place: place }) }) })), _jsxs("section", Object.assign({ className: scss.SendRequest__modalBlock2 }, { children: [_jsxs("aside", Object.assign({ className: scss.RathingPayDesc__Block }, { children: [_jsxs("div", Object.assign({ className: scss.RathingPay__Block }, { children: [_jsx(RathingBlock, { place: place }), _jsx(PaymentBlock, {})] })), _jsx(DescriptionBlock, {})] })), _jsxs("aside", { children: [_jsx(Feedback, {}), _jsx(Amenities, {})] })] })), _jsx("section", Object.assign({ className: scss.roomDetails }, { children: _jsx(RoomDetails, { place: place }) }))] })) })));
};
